import React, {useState, useEffect} from "react";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import {
    getDDQCategories,
    getDDQsubCategories,
    getDDQQuestions,
    insertOrUpdateDDQCategory,
    insertOrUpdateDDQSubCategory,
    insertOrUpdateDDQQuestion,
    deleteDDQCategory,
    deleteDDQSubCategory,
    deleteDDQQuestion,
    getAnswerTypes
} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { AgGridReact } from 'ag-grid-react';
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';

const DDQSetup = () => {
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` }, { BreadCrumb: "DDQ Setup", Routes: `${UrlPath.DDQSetup}` }];
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubcategory] = useState(null);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    useEffect(()=>{
        document.title="DDQ Setup";
    },[])
    useEffect(()=>{
        setSelectedSubcategory(null);
    },[selectedCategory]);
    return <>
        <TopBar label={"DDQ Setup"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4">
            <div className="row">
                <div className="col-6">
                    <CategoryGrid handleSelectedCategory={setSelectedCategory}/>
                </div>
                <div className="col-6">
                    <SubCategoryGrid selectedCategory={selectedCategory} handleSelectedSubCategory={setSelectedSubcategory}/>
                </div>
            </div>
            <div className="row d-flex mt-3">
                <QuestionGrid selectedSubCategory={selectedSubCategory} handleSelectedQuestion={setSelectedQuestion}/>
            </div>
            </div>
        </div>
        <ToastContainer/>
    </>
};

const CategoryGrid = ({handleSelectedCategory}) => {
    const [categories, setCategories] = useState([]);
    const [addDrawerOpen, setAddDrawerOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [saveData, setSaveData] = useState({});
    const [deleteData, setDeleteData] = useState({});
    const [showModal, setShowModal] = useState(false);

    const fetchCategories = async() => {
        try{
            const list = await sbaAxios({
                url:getDDQCategories
            });
            setCategories(list);
        }
        catch(e){
            setCategories([]);
        }
    };

    const actionCellRenderer = (params) => {
        return (
          <div
            className="actions-cell"
          >
            <i
                className="fas fa-edit"
                style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                onClick={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    handleEditCategory(params.data)
                }}
            ></i>
            <i
              className="fa fa-trash"
              style={{color: "red",margin: "0 8px",cursor: "pointer",}}
              onClick={(e)=>{
                e.stopPropagation();
                e.preventDefault();
                setDeleteData(params.data);
                setShowModal(true);
              }}
            ></i>
          </div>
        );
      };

    useEffect(()=>{
        fetchCategories();
    },[]);

    const handleAddCategory = () => {
        setEditMode(false);
        setSaveData({});
        setAddDrawerOpen(true);
      };
    
    const handleEditCategory = (data) => {
        setEditMode(true);
        setSaveData(data);
        setAddDrawerOpen(true);
    };

    const handleSaveCategory = async(data) => {
        if (!data?.CategoryName?.trim()){toast.error('Enter a valid Category Name.'); return}
        if (!data?.CategoryCode?.trim()){toast.error('Enter a valid Category Code.'); return}
        if (data?.CategoryCode?.trim().length >= 10) {toast.error("Category Code must be less than 10 characters."); return;}
        try{
            const postData = {
                categoryId: data?.CategoryId || 0,
                categoryName: data?.CategoryName,
                categoryCode: data?.CategoryCode
            }
            await sbaAxios({
                url:insertOrUpdateDDQCategory,
                data:postData,
                method:'post'
            }).then(res=>{
              if(res>0){
                fetchCategories();
                toast.success(`Category ${editMode?"Updated":"Added"} Successfully.`);
              }
              
              else 
              toast.error(`Category Name Already Exist`);
            })
        }
        catch(e){
            toast.error(`Unable to ${editMode?"Update":"Add"} Category.`);
        }
        finally{
            setSaveData({});
        }
    };

    const handleDeleteCategory = async() => {
        try{
            const response = await sbaAxios({
                url:deleteDDQCategory,
                params:{
                    categoryId:deleteData.CategoryId
                }
            })
            if(response === 1){
                toast.success('Category Deleted Successfully.');
                fetchCategories();
                return;
            }
            if(response === -1){
                toast.error('Cannot delete (Category has atleast one Sub Category).');
                return;
            }
        }
        catch(e){
            toast.error('Unable to delete Category');
        }
        finally{
            setShowModal(false);
        }
    };

    const colDefs = [
        {headerName:'Category', field:"CategoryName", minWidth:475},
        {headerName:'Category Code', field:"CategoryCode", minWidth:50},
        {headerName:'Actions', field:'Actions', minWidth:75,cellRenderer: actionCellRenderer,suppressRowClickSelection:true}
    ]

    return(
       <>
       <div className="row">
       <div className="d-flex justify-content-end gap-2">
            <button className='p-sm-btn mb-2' onClick={handleAddCategory}>Add Category</button>
          </div>
       </div>
       <div className="row">
       <div className="ag-theme-alpine" style={{ height: "400px", width: "100%", paddingTop: 0 }}>
            <AgGridReact
              rowData={categories}
              columnDefs={colDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              onRowClicked={(params) => {
                const colField = params.event?.target?.closest('.ag-cell')?.getAttribute('col-id');
                if (colField !== 'Actions'){
                  handleSelectedCategory(params.data);
                }
              }}
              rowSelection="single"
            />
          </div>
       </div>
       <AddEditDrawer
            open={addDrawerOpen}
            setOpen={setAddDrawerOpen}
            title={editMode ? "Edit Category" : "Add Category"}
            fields={[
                { name: "CategoryName", label: "Category Name", type: "text" },
                { name: "CategoryCode", label: "Category Code", type: "text" },
                // {
                // name: "expenseCategory",
                // label: "Expense Category",
                // type: "combobox",
                // data: category, // Pass the data for the combobox
                // textField: "ExpenseCategoryName", // Property name to display
                // valueField: "ExpenseCategoryId", // Property name for the value
                // popupSettings: { className: "modalDD" } // Custom popup settings
                // }
            ]}
            initialData={saveData}
            onSubmit={handleSaveCategory}
            onCancel={() => {
                setAddDrawerOpen(false);
                setEditMode(false);
                setSaveData({});
            }}
        />
        <DeleteModal deleteModalTitle={"Category"} deleteModal={showModal} setDeleteModal={setShowModal} handleDelete={handleDeleteCategory}/>
       </>
    )
}

const SubCategoryGrid = ({selectedCategory, handleSelectedSubCategory}) => {
    const [subCategories, setSubCategories] = useState([]);
    const [addDrawerOpen, setAddDrawerOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [saveData, setSaveData] = useState({});
    const [deleteData, setDeleteData] = useState({});
    const [showModal, setShowModal] = useState(false);
    
    const fetchSubCategories = async() => {
        try{
            const list = await sbaAxios({
                url:getDDQsubCategories,
                params:{
                    ddqCategoryId: selectedCategory.CategoryId
                }
            });
            setSubCategories(list);
        }
        catch(e){
            setSubCategories([]);
        }
    };

    const actionCellRenderer = (params) => {
        return (
          <div
            className="actions-cell"
          >
            <i
                className="fas fa-edit"
                style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                onClick={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    handleEditSubCategory(params.data)
                }}
            ></i>
            <i
              className="fa fa-trash"
              style={{color: "red",margin: "0 8px",cursor: "pointer",}}
              onClick={(e)=>{
                e.stopPropagation();
                e.preventDefault();
                setDeleteData(params.data);
                setShowModal(true);
              }}
            ></i>
          </div>
        );
      };

    useEffect(()=>{
        fetchSubCategories();
    },[selectedCategory]);

    const handleAddSubCategory = () => {
        setEditMode(false);
        setSaveData({});
        setAddDrawerOpen(true);
      };
    
    const handleEditSubCategory = (data) => {
        setEditMode(true);
        setSaveData(data);
        setAddDrawerOpen(true);
    };

    const handleSaveSubCategory = async(data) => {
        if (!data?.SubCategoryName?.trim()){toast.error('Enter a valid Sub Category Name.'); return}
        if (!data?.SubCategoryCode?.trim()){toast.error('Enter a valid Sub Category Code.'); return}
        if (data?.SubCategoryCode?.trim().length >= 10) {toast.error("Sub Category Code must be less than 10 characters."); return;}
        try{
            const postData = {
                subCategoryId: data?.SubCategoryId || 0,
                subCategoryName: data?.SubCategoryName,
                subCategoryCode: data?.SubCategoryCode,
                categoryId: selectedCategory.CategoryId
              }
            sbaAxios({
                url:insertOrUpdateDDQSubCategory,
                data:postData,
                method:'post'
            }).then(res=>{
              if(res>0)
              {
                toast.success(`Sub Category ${editMode?"Updated":"Added"} Successfully.`);
                fetchSubCategories();
              }
              else {
                toast.error(`Sub Category Name Already Exist`)
              }
            })
        }
        catch(e){
            toast.error(`Unable to ${editMode?"Update":"Add"} Sub Category.`);
        }
        finally{
            setSaveData({});
        }
    };

    const handleDeleteSubCategory = async() => {
        try{
            const response = await sbaAxios({
                url:deleteDDQSubCategory,
                params:{
                    subCategoryId:deleteData.SubCategoryId
                }
            })
            if(response === 1){
                toast.success('Sub Category Deleted Successfully.');
                fetchSubCategories();
                return;
            }
            if(response === -1){
                toast.error('Cannot delete (Sub Category has atleast one Question).');
                return;
            }
        }
        catch(e){
            toast.error('Unable to delete Sub Category');
        }
        finally{
            
            setShowModal(false);
        }
    };


    const colDefs = [
        {headerName:'Sub Category', field:"SubCategoryName", minWidth:450},
        {headerName:'Sub-Category Code', field:"SubCategoryCode", minWidth:75},
        {headerName:'Actions', field:'Actions',minWidth:75, cellRenderer: actionCellRenderer,suppressRowClickSelection:true}
    ]

    return(
        <>
        <div className="row">
            <div className="d-flex justify-content-end gap-2">
            <button className='p-sm-btn mb-2' onClick={handleAddSubCategory} disabled={!selectedCategory}>Add Sub Category</button>
          </div>
        </div>
        <div className="row">
        <div className="ag-theme-alpine" style={{ height: "400px", width: "100%", paddingTop: 0 }}>
            <AgGridReact
              rowData={subCategories}
              columnDefs={colDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              onRowClicked={(params) => {
                const colField = params.event?.target?.closest('.ag-cell')?.getAttribute('col-id');
                if(colField !== 'Actions'){
                  handleSelectedSubCategory(params.data)
                }
              }}
              rowSelection="single"
            />
        </div>
        </div>
        <AddEditDrawer
            open={addDrawerOpen}
            setOpen={setAddDrawerOpen}
            title={editMode ? "Edit Sub Category" : "Add Sub Category"}
            fields={[
                { name: "SubCategoryName", label: "Sub Category Name", type: "text" },
                { name: "SubCategoryCode", label: "Sub Category Code", type: "text" },
                // {
                // name: "expenseCategory",
                // label: "Expense Category",
                // type: "combobox",
                // data: category, // Pass the data for the combobox
                // textField: "ExpenseCategoryName", // Property name to display
                // valueField: "ExpenseCategoryId", // Property name for the value
                // popupSettings: { className: "modalDD" } // Custom popup settings
                // }
            ]}
            initialData={saveData}
            onSubmit={handleSaveSubCategory}
            onCancel={() => {
                setAddDrawerOpen(false);
                setEditMode(false);
                setSaveData({});
            }}
        />
        <DeleteModal deleteModalTitle={"Sub Category"} deleteModal={showModal} setDeleteModal={setShowModal} handleDelete={handleDeleteSubCategory}/>
        </>
    )
}

const QuestionGrid = ({selectedSubCategory, handleSelectedQuestion}) => {
    const [questions, setQuestions] = useState([]);
    const [addDrawerOpen, setAddDrawerOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [saveData, setSaveData] = useState({});
    const [deleteData, setDeleteData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [parentQuestions, setParentQuestions] = useState([]);
    const [selectedParentQuestion, setSelectedParentQuestion] = useState(null);
    const [answerTypes, setAnswerTypes] = useState([]);
    const [selectedAnswerType, setSelectedAnswerType] = useState(null);

    function filterNonHierarchy(data, parentId) {
      // Function to filter the hierarchy
      function filterHierarchy(data, parentId) {
        const hierarchy = [];
        const queue = [parentId];
    
        while (queue.length > 0) {
          const currentId = queue.shift();
          data.forEach(item => {
            if (item.ParentQuestionId === currentId) {
              hierarchy.push(item);
              queue.push(item.QuestionId);
            }
          });
        }
    
        return hierarchy;
      }
    
      // Get the items in the hierarchy
      const hierarchyItems = filterHierarchy(data, parentId);
      // Extract the QuestionIds of all items in the hierarchy
      const hierarchyIds = new Set(hierarchyItems.map(item => item.QuestionId));
    
      // Filter out items not in the hierarchy
      const nonHierarchyItems = data.filter(item => !hierarchyIds.has(item.QuestionId));
      
      return nonHierarchyItems;
    }
    
    const fetchQuestions = async() => {
        try{
            const list = await sbaAxios({
                url:getDDQQuestions,
                params:{
                  subCategoryId:selectedSubCategory.SubCategoryId
                }
            });
            setQuestions(list);
            setParentQuestions(list);
        }
        catch(e){
            setQuestions([]);
            setParentQuestions([]);
        }
    };

    const fetchAnswerTypes = async() => {
      try{
          const list = await sbaAxios({
              url:getAnswerTypes,
          });
          setAnswerTypes(list);
      }
      catch(e){
          setAnswerTypes([]);
      }
  };

    const actionCellRenderer = (params) => {
        return (
          <div
            className="actions-cell"
          >
            <i
                className="fas fa-edit"
                style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                onClick={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    handleEditQuestion(params.data)
                }}
            ></i>
            <i
              className="fa fa-trash"
              style={{color: "red",margin: "0 8px",cursor: "pointer",}}
              onClick={(e)=>{
                e.stopPropagation();
                e.preventDefault();
                setDeleteData(params.data);
                setShowModal(true);
              }}
            ></i>
          </div>
        );
    };

    useEffect(()=>{
        fetchQuestions();
        fetchAnswerTypes();
    },[selectedSubCategory]);

    useEffect(()=>{
      if(!addDrawerOpen){
        setParentQuestions(questions);
      }
    }, [addDrawerOpen]);

    const handleAddQuestion = () => {
        setEditMode(false);
        setSaveData({});
        setAddDrawerOpen(true);
      };
    
    const handleEditQuestion = (data) => {
        setEditMode(true);
        const selfRemovedParentQuestions = parentQuestions.filter((item) => item.QuestionId !== data.QuestionId)
        const nonHeirarchyQuestions = filterNonHierarchy(selfRemovedParentQuestions, data.QuestionId);
        nonHeirarchyQuestions.unshift({
          Question:'Please Select', QuestionId:-1, ParentQuestionId:-1
        });
        setParentQuestions(nonHeirarchyQuestions);
        // Update saveData with processed values
        setSelectedParentQuestion(questions.find((item) => item.QuestionId === data.ParentQuestionId))
        setSaveData({
            ...data, // Retain existing fields from the data object
            ParentQuestion: questions.find((item) => item.QuestionId === data.ParentQuestionId) || {},
            AnswerTypeName: answerTypes.find((item) => item.AnswerTypeId === data.AnswerTypeId)
        });
        setAddDrawerOpen(true);
    };

    const handleDeleteQuestion = async() => {
        try{
            const response = await sbaAxios({
                url:deleteDDQQuestion,
                params:{
                    questionId:deleteData.QuestionId
                }
            })

            toast.success('Question Deleted Successfully.');
            fetchQuestions();
        }
        catch(e){
            toast.error('Unable to delete Question');
        }
        finally{
            setShowModal(false);
        }
    }

    const handleSaveQuestion = async(data) => {
        if (!data?.Question?.trim()){toast.error('Enter a valid Question.'); return}
        if (!data?.QuestionTitle?.trim()){toast.error('Enter a valid Question Title'); return}
        try{
            const postData = {
                questionId: data?.QuestionId || 0,
                subCategoryId: selectedSubCategory.SubCategoryId,
                questionTitle: data?.QuestionTitle,
                question: data?.Question,
                parentQuestionId: selectedParentQuestion?.QuestionId < 0? 0: (selectedParentQuestion?.QuestionId || 0),
                indentLevel: Number(data?.IndentLevel) || 0,
                AnswerTypeId: selectedAnswerType.AnswerTypeId
              }
           const res= await sbaAxios({
                url:insertOrUpdateDDQQuestion,
                data:postData,
                method:'post'
            })
            if(res>0){
              toast.success(`Question ${editMode?"Updated":"Added"} Successfully.`);
              fetchQuestions();
            }
            else 
            toast.error(`Question Already Exist`);
          }
        catch(e){
            toast.error(`Unable to ${editMode?"Update":"Add"} Question.`);
        }
        finally{
            setSaveData({});
            setSelectedParentQuestion(null);
        }
        
    };

    const colDefs = [
        {headerName:'Question Id', field: 'QuestionId', minWidth:75},
        {headerName:'Question Title', field: "QuestionTitle", minWidth:175},
        {headerName:'Questions', field:"Question", minWidth:925},
        {headerName:'Question Parent Id', field:'ParentQuestionId', minWidth:100},
        {headerName:'Actions', field:'Actions', minWidth:75, cellRenderer: actionCellRenderer, suppressRowClickSelection:true}
    ]

    return(
        <>
        <div className="row">
        <div className="d-flex justify-content-end gap-2">
            <button className='p-sm-btn mb-2' onClick={handleAddQuestion} disabled={!selectedSubCategory}>Add Question</button>
          </div>
        </div>
        <div className="row">
        <div className="ag-theme-alpine" style={{ height: "400px", width: "100%", paddingTop: 0 }}>
            <AgGridReact
              rowData={questions}
              columnDefs={colDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              onRowClicked={(params) => {
                const colField = params.event?.target?.closest('.ag-cell')?.getAttribute('col-id');
                if(colField !== 'Actions'){
                  handleSelectedQuestion(params.data)
                }
              }}
              rowSelection="single"
            />
          </div>
        </div>
        <AddEditDrawer
            open={addDrawerOpen}
            setOpen={setAddDrawerOpen}
            title={editMode ? "Edit Question" : "Add Question"}
            fields={[
                { name: "QuestionTitle", label: "Question Title", type: "text" },
                //{ name: "NoteSubTypeId", label: "Note Sub Type", type: "number" },
                {
                name: "ParentQuestion",
                label: "Parent Question",
                type: "combobox",
                data: parentQuestions, // Pass the data for the combobox
                textField: "Question", // Property name to display
                valueField: "QuestionId", // Property name for the value
                onChange:setSelectedParentQuestion,
                popupSettings: { className: "modalDD" } // Custom popup settings
                },
                { name: "Question", label: "Question", type: "text" },
                {
                  name: "AnswerTypeName",
                  label: "Answer Type",
                  type: "combobox",
                  data: answerTypes, // Pass the data for the combobox
                  textField: "AnswerTypeName", // Property name to display
                  valueField: "AnswerTypeId", // Property name for the value
                  onChange:setSelectedAnswerType,
                  popupSettings: { className: "modalDD" } // Custom popup settings
                  },
                { name: "IndentLevel", label: "Indent Level", type: "number" },
            ]}
            initialData={saveData}
            onSubmit={handleSaveQuestion}
            onCancel={() => {
                setAddDrawerOpen(false);
                setEditMode(false);
                setSaveData({});
            }}
        />
        <DeleteModal deleteModalTitle={"Question"} deleteModal={showModal} setDeleteModal={setShowModal} handleDelete={handleDeleteQuestion}/>
        </>
    )
}

const AddEditDrawer = ({
    open,
    setOpen,
    title,
    fields = [],
    onSubmit,
    onCancel,
    initialData = {}
  }) => {
    const [formValues, setFormValues] = useState(initialData);

    useEffect(() => {
        setFormValues(initialData); // Sync state with initialData
    }, [initialData]); // Trigger whenever initialData changes

    const handleChange = (name, value) => {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleNumberInput = (name, value) => {
        // Restrict to integer values
        if (!isNaN(value) && Number.isInteger(+value)) {
          handleChange(name, value);
        }
      };
  
    const handleSave = () => {
      onSubmit(formValues);
      setOpen(false);
      setFormValues({})
    };
  
    const handleCancel = () => {
      onCancel();
      setOpen(false);
      setFormValues({})
    };
  
    return (
      <SBADrawer open={open} setOpen={setOpen} title={title} style={{ width: "40vw" }}>
        <div className="row">
          {fields.map(({ name, label, type, options, data, textField, valueField, value, onChange, popupSettings }, index) => (
            <div className="col-12 mb-3" key={index}>
              {type === "text" && (
                <>
                  <label className="form-label">{label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formValues[name] || ""}
                    onChange={(e) => handleChange(name, e.target.value)}
                  />
                </>
              )}
              {type === "number" && (
              <>
                <label className="form-label">{label}</label>
                <input
                  type="number"
                  className="form-control no-arrows"
                  value={formValues[name] ?? ""}
                  onChange={(e) => handleNumberInput(name, e.target.value)}
                  onKeyDown={(e) => {
                    // Prevent non-integer characters except allowed keys (Backspace, Delete, Tab, Arrow Keys)
                    const invalidKeys = ["e", "E", "+", "-", "."];
                    if (invalidKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </>
            )}
              {type === "combobox" && (
                <>
                  <label className="form-label">{label}</label>
                  <SBAComboBox
                    className="w-100"
                    data={data}
                    textField={textField}
                    valueField={valueField}
                    value={formValues[name]}
                    onChange={(e) => {
                      handleChange(name, e.value);
                      if(name === "ParentQuestion"){
                        handleChange("IndentLevel", e.value?.IndentLevel+1 || 0)
                      }
                      if (typeof onChange === "function") {
                        onChange(e.value); // Call the external onChange if provided
                      }
                    }}
                    popupSettings={popupSettings}
                  />
                </>
              )}
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button className="btn btn-primary" onClick={handleSave}>
            Save
          </button>
          <button className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </SBADrawer>
    );
  };
  

const DeleteModal = ({deleteModal, deleteModalTitle, setDeleteModal, handleDelete}) => {
    return(
        <>
        <Modal show={deleteModal} onHide={()=>setDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete {deleteModalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              Do you really want to delete the selected {deleteModalTitle}?
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setDeleteModal(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleDelete}
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
        </>
    )
}

export default DDQSetup;